export default __webpack_public_path__ + "static/logo_client_turner@2x-713237fd08f7ee3c987db58d786358d5.png";